import React from 'react';
import CreateOrEditPractitioners from 'src/components/DashboardAdministrator/Practitioners/CreateOrEditPractitioners';

const MedspaAccountSettings = () => <CreateOrEditPractitioners />;

export default MedspaAccountSettings;
